import * as itemsApi from './itemsApi.js';
import * as parametersApi from './parametersApi.js';
import * as recipesApi from './recipesApi.js';
import * as projectsApi from './projectsApi.js';
import * as versionsApi from './versionsApi.js';
import * as parameterGroupsApi from './parameterGroupsApi.js';
import * as valueTypesApi from './valueTypesApi.js';
import * as entitiesApi from './entitiesApi.js';

/**
 * Unified Content API (v2)
 *
 * - Projects:        getProjects, getProjectById, createProject, patchProject, renameProjectSystemName, deleteProject
 * - Versions:        getVersions, getVersionById, forkVersion, patchVersion, publishVersion, archiveVersion, deleteVersion
 * - Entities:        getEntities, getEntityById, createEntity, patchEntity, renameEntitySystemName, deleteEntity, ...
 * - Items:           getItems, getItemById, createItem, patchItem, renameItemSystemName, deleteItem, ...
 * - Parameters:      getParametersPaged, getParameterById, createParameter, patchParameter, renameParameterSystemName, deleteParameter
 * - ParameterGroups: getParameterGroups, getParameterGroupById, createParameterGroup, patchParameterGroup, deleteParameterGroup, ...
 * - Recipes:         getRecipes, getRecipeById, createRecipe, patchRecipe, renameRecipeSystemName, deleteRecipe, ...
 * - ValueTypes:      getValueTypes, getValueTypeByCode
 */
export const ContentApi = {
    // Projects API
    ...projectsApi,

    // Versions API
    ...versionsApi,

    // Generic Entities API
    ...entitiesApi,

    // Items API
    ...itemsApi,

    // Parameters API
    ...parametersApi,

    // ParameterGroups API
    ...parameterGroupsApi,

    // Recipes API
    ...recipesApi,

    // ValueTypes API
    ...valueTypesApi,
};

// Also export individual modules for direct access if needed
export {
    projectsApi,
    versionsApi,
    entitiesApi,
    itemsApi,
    // buildingsApi,
    // categoriesApi,
    parametersApi,
    parameterGroupsApi,
    recipesApi,
    valueTypesApi,
};
